/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CaseTypeDto } from './CaseTypeDto';
import {
    CaseTypeDtoFromJSON,
    CaseTypeDtoFromJSONTyped,
    CaseTypeDtoToJSON,
    CaseTypeDtoToJSONTyped,
} from './CaseTypeDto';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface CaseTypeListResponse
 */
export interface CaseTypeListResponse {
    /**
     * 
     * @type {string}
     * @memberof CaseTypeListResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof CaseTypeListResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof CaseTypeListResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof CaseTypeListResponse
     */
    timezoneMetadata?: TimezoneMetadata;
    /**
     * 
     * @type {Array<CaseTypeDto>}
     * @memberof CaseTypeListResponse
     */
    data?: Array<CaseTypeDto>;
    /**
     * 
     * @type {number}
     * @memberof CaseTypeListResponse
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof CaseTypeListResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CaseTypeListResponse
     */
    pageSize?: number;
}

/**
 * Check if a given object implements the CaseTypeListResponse interface.
 */
export function instanceOfCaseTypeListResponse(value: object): value is CaseTypeListResponse {
    return true;
}

export function CaseTypeListResponseFromJSON(json: any): CaseTypeListResponse {
    return CaseTypeListResponseFromJSONTyped(json, false);
}

export function CaseTypeListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseTypeListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(CaseTypeDtoFromJSON)),
        'total': json['total'] == null ? undefined : json['total'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}

export function CaseTypeListResponseToJSON(json: any): CaseTypeListResponse {
    return CaseTypeListResponseToJSONTyped(json, false);
}

export function CaseTypeListResponseToJSONTyped(value?: CaseTypeListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(CaseTypeDtoToJSON)),
        'total': value['total'],
        'page': value['page'],
        'pageSize': value['pageSize'],
    };
}

